import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation, inject, signal } from '@angular/core';
import type { SafeHtml } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-svg-icon',
  imports: [],
  template: `<div class="tw-h-full" [innerHTML]="html()"></div>`,
  styles: `
    app-svg-icon {
      display: block;
    }

    app-svg-icon > div > svg {
      width: 100%;
      height: 100%;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SvgIconComponent {
  readonly #sanitizer = inject(DomSanitizer);
  readonly #http = inject(HttpClient);

  protected readonly html = signal<SafeHtml | undefined>(undefined);

  @Input({ required: true }) set src(value: string) {
    this.#fetchSvg(value);
  }

  async #fetchSvg(url: string): Promise<void> {
    const res = await lastValueFrom(this.#http.get(url, { responseType: 'text' }));
    this.html.set(this.#sanitizer.bypassSecurityTrustHtml(res));
  }
}
